import { defineMessages } from 'react-intl';

export const TextFieldQuestionFormMessages = defineMessages({
  questionFormQuestionValidationLabel: {
    id: `app.components.FormBuilder.QuestionTypeForms.CommonQuestionForm.questionFormQuestionValidationLabel`,
    defaultMessage: 'Regular expression',
  },
  questionFormQuestionValidationMessageLabel: {
    id: `app.components.FormBuilder.QuestionTypeForms.CommonQuestionForm.questionFormQuestionValidationMessageLabel`,
    defaultMessage: 'Validation error message',
  },
});
